import React from "react";
import { useTranslation } from 'react-i18next';

export default function Intro() {
  const { t } = useTranslation();
  return (
    <>
      <div className="intro-wrapper">
        <h1>{t('title')} Arbox</h1>
      </div>
      <div className="journey-instruction">
        <p>{t('introduction')}</p>
      </div>
    </>
  );
}
